module.exports = __webpack_public_path__ + "img/services-shape-2.01b3f8b0.svg";